import apiFetch from '../apiFetch'

export default function (token, styleTask) {
  return apiFetch({ endPoint: 'StyleTask', method: 'PUT', body: styleTask, token: token })
}
